import { FASTElement as e, html as m } from "@microsoft/fast-element";
import { tableHeaderStyles as o } from "./thead.styles.js";
const t = class t extends e {
};
t.definition = {
  name: "thead",
  template: () => m` <slot></slot>`,
  styles: o
};
let s = t;
export {
  s as TableHeader
};
